import React, { useEffect } from "react";
import BannerCarousel from "./BannerCarousel";
import BestSellers from "./BestSellers";
import OurSpecials from "./OurSpecials";
import HomeCategories from "./HomeCategories";
import AvonsSpecials from "./AvonsSpecials";
// import FestivalSpecials from "./FestivalSpecials";
import WhyChooseUs from "./WhyChooseUs";
import CustomerTestimonials from "./CustomerTestimonials";
import InstagramReels from "./InstagramReels";
// import NewsletterSignup from "./NewsletterSignup";
import AboutUs from "./AboutUs";
import FooterBanner from "./FooterBanner";
import MetaTags from "../Common/MetaTags";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);


  return (
    <section>
      <MetaTags
        module="home"
        title="Welcome"
        image=""
        description={`Avon Namkeen is a leading manufacturer and supplier of namkeens and Indian snacks.`}
      />

      {/* Hero Section - Keep unchanged as requested */}
      <BannerCarousel />

      {/* Best Sellers - Redesigned with modern styling */}
      <BestSellers />

      {/* Featured Categories - Redesigned with elegant grid layout */}
      <HomeCategories />

      {/* Avon's Specials - New section with special products */}
      <AvonsSpecials />

      {/* Our Specials - Keep existing */}
      <OurSpecials />

      {/* Festival Specials - New section */}
      {/* <FestivalSpecials /> */}

      {/* Why Choose Us - New section */}
      <WhyChooseUs />

      {/* Customer Testimonials - New section */}
      <CustomerTestimonials />

      {/* Instagram Reels - New section */}
      <InstagramReels />

      {/* Newsletter Signup - New section */}
      {/* <NewsletterSignup /> */}

      {/* About Us - Keep existing */}
      <AboutUs />

      {/* Footer Banner - Keep existing */}
      <FooterBanner />
    </section>
  );
};

export default HomePage;
